import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch} from "../../../../../../../../app/hooks";
import {
    selectGtmAnalyticsEnabled,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";
import {
    CustomSwitchFieldWithTitle
} from "../../../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";

interface AnalyticsSettingsProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const AnalyticsSettings: React.FC<AnalyticsSettingsProps> = ({
                                                                    getMessageWrapper,
                                                                    updateValidationStatus
                                                                }) => {
    const dispatch = useAppDispatch();

    return (
        <AppearanceTabSettingsContainer title="Analytics">
            <div className={styles.fieldsLine}>
                <CustomSwitchFieldWithTitle
                    textOnTrue={"Enabled"}
                    textOnFalse={"Disabled"}
                    title={"Google Tag Manager Analytics"}
                    description={'Enable GTM analytics tracking for widget interactions'}
                    valueSelector={selectGtmAnalyticsEnabled}
                    toggleValue={(v) => dispatch(updateSettings({
                        gtmAnalyticsEnabled: v
                    }))}
                />
            </div>
        </AppearanceTabSettingsContainer>
    );
};

